import { isRequired } from 'utils/validate/validate';
import { FORMULARIOS, MSG_TAMANHO_MIN_JUSTIFICATIVA } from 'utils/consts';
import { getAssuntoUrl } from 'utils/funcaoPadrao';
import { validationsPessoaCreate } from './dadosCadastrais';

export const validationsCreate = dadosInputs => {
  const { servico } = dadosInputs;

  const errosCampos = { ...validationsPessoaCreate(dadosInputs), servico: null, justificativa: null };

  // REQUERIMENTO SERVICO
  if (getAssuntoUrl() === FORMULARIOS.SERVICOS.id) {
    errosCampos.servico = isRequired(servico);
  }

  let tamanhoMinimoJustificativa = dadosInputs?.justificativa?.toString()?.trim()?.length < 15;

  if (dadosInputs.justificativa && tamanhoMinimoJustificativa)
    errosCampos.justificativa = MSG_TAMANHO_MIN_JUSTIFICATIVA;
  else errosCampos.justificativa = isRequired(dadosInputs.justificativa);

  return errosCampos;
};
